import styled from '@emotion/styled';

export const TabContainer = styled.button`
  border: none;
  background: transparent;
  border-bottom: 4px solid #c8c8c8;
  padding: 24px;

  &.active {
    color: #005cb9;
    font-weight: 700;
    border-color: #005cb9;
  }
`;
